const clamp = (value, min, max) => {
  if (typeof min === "number" && value < min) {
    return min;
  }
  if (typeof max === "number" && value > max) {
    return max;
  }
  return value;
};

const dialogDrag = {
  inserted(el) {
    const header = el.querySelector(".el-dialog__header");
    const dialog = el.querySelector(".el-dialog");
    if (!header || !dialog) {
      return;
    }
    header.style.cursor = "move";

    const onMouseDown = (event) => {
      event.preventDefault();
      const startX = event.clientX;
      const startY = event.clientY;
      const rect = dialog.getBoundingClientRect();
      const startLeft = rect.left;
      const startTop = rect.top;
      dialog.style.margin = "0";
      dialog.style.transform = "none";
      dialog.style.left = `${startLeft}px`;
      dialog.style.top = `${startTop}px`;
      dialog.style.right = "auto";
      dialog.style.bottom = "auto";
      dialog.style.position = "fixed";

      const onMouseMove = (moveEvent) => {
        const deltaX = moveEvent.clientX - startX;
        const deltaY = moveEvent.clientY - startY;
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = document.documentElement.clientHeight;
        const dialogRect = dialog.getBoundingClientRect();
        const maxLeft = Math.max(0, viewportWidth - dialogRect.width);
        const maxTop = Math.max(0, viewportHeight - dialogRect.height);
        const nextLeft = clamp(startLeft + deltaX, 0, maxLeft);
        const nextTop = clamp(startTop + deltaY, 0, maxTop);
        dialog.style.left = `${nextLeft}px`;
        dialog.style.top = `${nextTop}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    };

    header.addEventListener("mousedown", onMouseDown);
    el.__dialogDragCleanup__ = () => {
      header.removeEventListener("mousedown", onMouseDown);
    };
  },
  unbind(el) {
    if (typeof el.__dialogDragCleanup__ === "function") {
      el.__dialogDragCleanup__();
      delete el.__dialogDragCleanup__;
    }
  },
};

export default dialogDrag;
